var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmerald(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 60,
    viewBox: "0 0 63 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5205 19.7035L57.8945 14.7865L51.4475 8.34045L46.5305 15.7145L50.5205 19.7035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5305 43.2535L51.4475 50.6285L57.8945 44.1805L50.5195 39.2645L46.5305 43.2535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9565 38.3535L58.1795 43.1685L58.1795 15.7985L50.9565 20.6155L50.9565 38.3535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8365 15.8835L10.9205 8.50854L4.52951 14.8995L11.9035 19.8165L15.8365 15.8835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9045 39.1515L4.52949 44.0685L10.9205 50.4595L15.8375 43.0845L11.9045 39.1515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5805 38.2915L11.5805 20.6765L11.5215 20.7645L4.35651 15.9864L4.35651 42.9814L11.5215 38.2044L11.5805 38.2915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6195 15.2785L50.4355 8.05554L11.8195 8.05554L16.6355 15.2785L45.6195 15.2785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6365 43.6885L11.8195 50.9135L50.4355 50.9135L45.6185 43.6885L16.6365 43.6885Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9565 20.5544L45.6805 16.2784L16.8555 16.2784L12.5805 20.5544L12.5805 38.4134L16.8555 42.6884L45.6805 42.6884L49.9565 38.4134L49.9565 20.5544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1795 44.3095L59.1795 14.6575L51.5795 7.05749L10.9595 7.05749L3.3595 14.6575L3.3595 15.1935L3.30151 15.2805L3.3595 15.3195L3.3595 43.6505L3.3015 43.6885L3.3595 43.7765L3.3595 44.3115L10.9595 51.9115L51.5765 51.9115L59.1795 44.3095ZM51.4475 50.6285L46.5305 43.2505L50.5195 39.2615L57.8945 44.1805L51.4475 50.6285ZM45.6805 42.6885L16.8555 42.6885L12.5805 38.4135L12.5805 20.5505L16.8555 16.2745L45.6805 16.2745L49.9565 20.5505L49.9565 38.4135L45.6805 42.6885ZM58.1805 43.1685L50.9565 38.3505L50.9565 20.6155L58.1795 15.7985L58.1805 43.1685ZM57.8955 14.7865L50.5215 19.7035L46.5315 15.7145L51.4475 8.34049L57.8955 14.7865ZM50.4355 8.05549L45.6195 15.2785L16.6355 15.2785L11.8195 8.05549L50.4355 8.05549ZM4.5295 14.8995L10.9205 8.50849L15.8365 15.8835L11.9035 19.8165L4.5295 14.8995ZM4.35651 15.9865L11.5215 20.7645L11.5805 20.6765L11.5805 38.2915L11.5215 38.2045L4.3565 42.9815L4.35651 15.9865ZM4.5295 44.0685L11.9045 39.1505L15.8375 43.0835L10.9205 50.4585L4.5295 44.0685ZM11.8195 50.9135L16.6365 43.6885L45.6185 43.6885L50.4355 50.9135L11.8195 50.9135Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.762,
    height: 61.263,
    fill: "white",
    transform: "translate(62.0125 0.250488) rotate(90)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmerald);
export default __webpack_public_path__ + "static/media/emerald.c4b65e9d1a23b8433140fc2060183369.svg";
export { ForwardRef as ReactComponent };